var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "RouterLink",
    {
      staticClass: "block text-sky-blue cursor-pointer focus!:outline-none",
      attrs: {
        to: {
          name: _vm.projectDetailsRoute,
          params: { id: _vm.project.id },
        },
      },
    },
    [
      _c("div", { staticClass: "projects-card-res" }, [
        _c(
          "div",
          { staticClass: "p-4" },
          [
            _c(
              "div",
              { staticClass: "flex flex-row justify-between" },
              [
                _vm.getProjectStatus === _vm.projectStatus.NEW_VISITS
                  ? _c("Badge", {
                      staticClass: "text-badge",
                      attrs: {
                        color: _vm.BadgeColor.SUCCESS,
                        value: "New visits",
                      },
                    })
                  : _vm.getProjectStatus === _vm.projectStatus.UPCOMING
                  ? _c("Badge", {
                      staticClass: "text-primary",
                      attrs: {
                        color: _vm.BadgeColor.INFO,
                        value: "Upcoming visit",
                      },
                    })
                  : _vm.getProjectStatus === _vm.projectStatus.NO_UPCOMING
                  ? _c("Badge", {
                      staticClass: "text-badge capitalize",
                      attrs: {
                        styleClasses: "py-0.5 px-2",
                        color: _vm.BadgeColor.OFFERED,
                        value: "No upcoming visits",
                      },
                    })
                  : _vm._e(),
                _c("UiButton", {
                  attrs: {
                    buttonText: "View visits",
                    variant: "black",
                    size: "sm",
                  },
                  on: { click: _vm.onActivityListItemAdded },
                  scopedSlots: _vm._u([
                    {
                      key: "icon",
                      fn: function () {
                        return [_c("ViewIcon", { staticClass: "w-3 h-3" })]
                      },
                      proxy: true,
                    },
                    {
                      key: "hover-icon",
                      fn: function () {
                        return [_c("ViewIconBlack", { staticClass: "w-4 h-4" })]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("div", { staticClass: "project-name focus:!outline-none" }, [
              _c("div", [
                _c("p", { staticClass: "text-sky-blue mb-2" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.project.client_name
                          ? _vm.project.client_name
                          : "n/a"
                      ) +
                      " "
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "company-name" }, [
              _vm._v("Created on: " + _vm._s(_vm.createdDate)),
            ]),
            _c("div", { staticClass: "location" }, [
              _c(
                "div",
                { staticClass: "flex flex-row" },
                [
                  _c("LocationIcon", {
                    staticClass: "w-4 h-4 mr-1 minWidthFitContent mt-1",
                  }),
                  _vm.project.address
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "text-sky-blue text-sm font-normal font-outfit",
                          attrs: {
                            href: `https://www.google.com/maps/place/${_vm.project.address}`,
                            target: "_blank",
                          },
                        },
                        [_vm._v(_vm._s(_vm.project.address))]
                      )
                    : _c(
                        "p",
                        {
                          staticClass:
                            "text-sky-blue text-sm font-normal font-outfit",
                        },
                        [_vm._v(" n/a ")]
                      ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "flex gap-1 w-full items-center mt-3 customMinHieght",
              },
              [
                _c("span", { staticClass: "team-teams" }, [_vm._v("Manager:")]),
                _vm.project.manager
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-1 items-center" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "manager-chip flex flex-row items-center",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "bg-primary-500 rounded-full flex items-center text-xs flex-shrink-0 justify-center text-white manager-image",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.project.manager.user.given_name.toUpperCase()[0]
                                      ) +
                                      _vm._s(
                                        _vm.project.manager.user.family_name.toUpperCase()[0]
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm._v(" " + _vm._s(_vm.projectManager) + " "),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _c("p", [_vm._v("n/a")]),
                _vm.project.manager
                  ? _c(
                      "ColorIconContainer",
                      {
                        staticClass: "flex justify-center items-center h-6 w-6",
                        attrs: { iconStyle: "" },
                        on: { click: _vm.message },
                      },
                      [_c("MessageIcon")],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("ActionSection", {
              attrs: {
                actionObject: _vm.getActionSectionValues,
                mainContainerStyle: "mainContainerStyle",
                currentUser: _vm.currentUser,
              },
            }),
          ],
          1
        ),
        _vm.showActivities
          ? _c(
              "div",
              { staticClass: "flex flex-col justify-end p-10 pb-0" },
              _vm._l(_vm.project.project_activities, function (activity) {
                return _c(
                  "div",
                  { key: activity.id },
                  [
                    _vm._t("activities", null, {
                      title: activity.title,
                      startDate: activity.start_date,
                      endDate: activity.end_date,
                      budget: activity.budget,
                      requestedHours: activity.requested_hours,
                      approvedHours: activity.confirmed_hours,
                    }),
                  ],
                  2
                )
              }),
              0
            )
          : _vm._e(),
        _vm.canEditProject
          ? _c(
              "div",
              { staticClass: "flex ml-auto items-center" },
              [
                _c("UiButton", {
                  attrs: {
                    buttonText: "Edit",
                    variant: "linkButton",
                    size: "no",
                  },
                  nativeOn: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleEditClick.apply(null, arguments)
                    },
                  },
                }),
                _c("UiButton", {
                  staticClass: "ml-4",
                  attrs: {
                    buttonText: "Add task",
                    variant: "linkButton",
                    size: "no",
                  },
                  nativeOn: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.openActivityModal.apply(null, arguments)
                    },
                  },
                }),
                _vm.hasParticipants
                  ? _c(
                      "ColorIconContainer",
                      {
                        staticClass: "ml-2.5 mt-0.5",
                        attrs: { iconStyle: "" },
                        on: { click: _vm.groupMessage },
                      },
                      [_c("ChatIcon")],
                      1
                    )
                  : _vm._e(),
                _vm.dialog
                  ? _c("ProjectModal", {
                      attrs: {
                        data: _vm.project,
                        companyId: _vm.companyId,
                        currentUser: _vm.currentUser,
                      },
                      on: {
                        close: function ($event) {
                          _vm.dialog = false
                        },
                        projectUpdated: function ($event) {
                          return _vm.$emit("projectUpdated")
                        },
                      },
                    })
                  : _vm._e(),
                _vm.activityModalOpened
                  ? _c("ActivityFormModal", {
                      attrs: {
                        project: _vm.project,
                        currentUserId: _vm.currentUser.id,
                        currentUserRole: _vm.currentUser.role,
                        companyId: _vm.companyId,
                      },
                      on: {
                        activityAdded: _vm.onActivityListItemAdded,
                        close: function ($event) {
                          _vm.activityModalOpened = false
                        },
                      },
                    })
                  : _vm._e(),
                _c("CreateGroupConversationModal", {
                  attrs: {
                    companyId: _vm.companyId,
                    currentUserId: _vm.currentUser.id,
                    groupConversationUsers: _vm.projectUsers,
                    projectTitle: _vm.title,
                  },
                  model: {
                    value: _vm.newConversationDialog,
                    callback: function ($$v) {
                      _vm.newConversationDialog = $$v
                    },
                    expression: "newConversationDialog",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }